import { useTranslation } from "react-i18next";
import { Box, Divider, Text } from "@hawkins/components";
import { Dimensions } from "@hawkins/variables";

import { Page } from "../Page";
import { StatusBanner } from "../StatusBanner";
import { TranslationNamespace } from "../../types";
import { EmergencyRequestCTA } from "../EmergencyRequestCTA";

export default function Pending() {
  const { t } = useTranslation(TranslationNamespace.LEP);

  return (
    <Page>
      <Box
        display="grid"
        gridTemplateColumns={"1fr"}
        placeItems="flex-start"
        rowGap={Dimensions.Space16}
      >
        <StatusBanner
          text={t('request_pending_banner')}
          variant="pending"
        />

        <Text bold gutterTop={Dimensions.Space6}>
          {t('request_registration_instructions')}
        </Text>

        <Divider
          style={{
            marginTop: Dimensions.Space8,
            marginBottom: Dimensions.Space6,
          }}
        />

        <EmergencyRequestCTA />
      </Box>
    </Page>
  );
};
